import { IMakeRequest } from '../helpers/network_helper';
import { INewbuildingRecommendations } from '../models/newbuilding_recommendations';

export const getNewbuildingRecommendationsApi = (makeRequest: IMakeRequest, regionId: number = 1) => {
  const locationHost = window.location.host;
  const host = /beta\d+\./.test(locationHost) ? locationHost.replace(/www\.beta(\d+)/, 'beta$1.api') : 'api.cian.ru';

  return makeRequest({
    method: 'GET',
    uri: {
      host,
      path: `/newbuilding-search/v1/get-newbuilding-recommendations/?regionId=${regionId}&size=4&pageType=desktop`,
    },
  }).then((res: {newbuildings: INewbuildingRecommendations[]}) => res.newbuildings);
};
